import { Organization, UDPOption } from ".";
import { GameStreamProtocol } from "./GameStream";
import { ClientDeviceType } from "./UserAgent";

export enum FEATURE_FLAG {
  ALLOW_NAVIGATION_SUBSCRIPTION_KO = "navigationOutOfSubscription",
  PIN_RESET_EMAIL = "pinResetByEmail",
}
export interface Config {
  bandwidthUrl: string;
  commandsUrl: string;
  homePageId: string;
  languages: { [id: string]: string };
  providers: Provider[];
  videoUrl: string;
  userConf?: UserConfig;
  organization?: Organization;
  features?: Partial<
    Record<
      | "faq"
      | "lemag"
      | "newsletter"
      | "notifications"
      | "password"
      | "payment"
      | "receipt"
      | "subscription"
      | "themes"
      | "support"
      | "pinresetDisconnect"
      | "email"
      | "ericssonBoost"
      | "ericssonBoostSubscribed"
      | "accountManagement"
      | "discord"
      | "surmafacture"
      | FEATURE_FLAG
      | string,
      boolean
    >
  >;
  privateRelay: boolean;
  loginMsisdn: boolean;
  deviceKind: ClientDeviceType;
  preferredCountry?: string;
  warmupVideoUrl?: string;
}
export interface Provider {
  id: string;
  speedtestIcmpServer: string;
  speedtestTCPServer: string;
  speedtestUDPServer: string;
  speedtestBlacknutServer: string;
  port: number;
}

export declare type DecodingType = "software" | "hardware";
export declare type SoundPipeline = "GStreamer" | "live666";

export enum PlayerLogLevel {
  TRACE = "trace",
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
}

export enum PlayerType {
  // Legacy player using Bobomb
  LEGACY = "legacy",
  // Native player on Android using GStreamer & webrtc
  GST_PLAYER = "nativewebrtc",
  // Fullweb webrtc player
  WEBRTC = "webrtc",
}
export interface UserConfig {
  levelLogClient?: "trace" | "debug" | "info" | "warn";
  levelLogPlayer?: PlayerLogLevel;
  protocol?: GameStreamProtocol;
  rtpDelay?: number;
  udpOption?: UDPOption;
  decoding?: DecodingType;
  soundPipeline?: SoundPipeline;
  streamStats?: boolean;
  // gamepad polling in the catalog
  gamepadPollingIntervalEdito?: number;

  // gamepad polling in the catalog
  gamepadPollingIntervalGame?: number;

  // player
  player?: PlayerType;
}
